<svg width="140" height="89" viewBox="0 0 140 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="graphic">
        <rect id="Rectangle 415" width="140" height="89" rx="4" fill="currentColor"/>
        <rect id="Rectangle 417" x="8" y="12" width="124" height="65" rx="2" fill="#C1D1DF"/>
    </g>
</svg>
